export default __webpack_public_path__ + "static/media/logo.4ff1a165.png";